import {claimDeposit, getDepositsConfig} from '@/api/funds';
import {useWalletStore} from '@/store/wallet';

type PendingDeposit={txHash:string;wallet:string;chainId:number;createdAt:number};
const keyFor=(wallet:string)=>`pending-deposits:v1:${wallet.toLowerCase()}`;
const inFlight=new Map<string,Promise<void>>();
function read(wallet:string):PendingDeposit[]{
  const saved=uni.getStorageSync(keyFor(wallet));
  return Array.isArray(saved)?saved:[];
}
export function rememberDeposit(input:{txHash:string;wallet:string;chainId:number}){
  const item={...input,txHash:input.txHash.toLowerCase(),wallet:input.wallet.toLowerCase(),createdAt:Date.now()};
  if(!/^0x[0-9a-f]{64}$/.test(item.txHash)||!/^0x[0-9a-f]{40}$/.test(item.wallet)||!Number.isSafeInteger(item.chainId))throw new Error('Invalid broadcast deposit');
  const pending=read(item.wallet);
  if(!pending.some(p=>p.txHash===item.txHash&&p.chainId===item.chainId)){
    uni.setStorageSync(keyFor(item.wallet),[...pending,item]);
  }
}
// A successful claim means the server owns recovery; it does NOT mean credited.
// Failed/unknown submissions remain durable and never initiate another transfer.
export function retryPendingDeposits():Promise<void>{
  const store=useWalletStore(),wallet=String(store.address||'').toLowerCase();
  if(!store.isAuthenticated||!wallet)return Promise.resolve();
  const active=inFlight.get(wallet);if(active)return active;
  const task=(async()=>{
    const rows=read(wallet);if(!rows.length)return;
    const config=await getDepositsConfig({expectedWallet:wallet,showError:false});
    for(const item of rows){
      if(!store.isAuthenticated||String(store.address||'').toLowerCase()!==wallet)return;
      if(item.wallet!==wallet||item.chainId!==config.chainId)continue;
      try{
        const response=await claimDeposit(item.txHash,{expectedWallet:wallet});
        if(String(response.txHash||'').toLowerCase()!==item.txHash)continue;
        // Re-read storage so a concurrent new broadcast cannot be lost.
        uni.setStorageSync(keyFor(wallet),read(wallet).filter(p=>p.txHash!==item.txHash||p.chainId!==item.chainId));
      }catch{ /* Keep this hash for the next foreground retry. */ }
    }
  })().catch(()=>undefined).finally(()=>inFlight.delete(wallet));
  inFlight.set(wallet,task);return task;
}
